import React, { useMemo } from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { Button } from "@/components/Button/Button";
import DataTable from "@/components/Datatable/Datatable";
import { useProcessWheels } from "../../hooks/useProcessWheels";
import { createProcessWheelColumns } from "../ProcessWheelColumns/ProcessWheelColumns";
import ProcessWheelFilters from "../ProcessWheelFilters/ProcessWheelFilters";
import CreateProcessWheelDrawer from "../CreateProcessWheelDrawer/CreateProcessWheelDrawer";
import EditProcessWheelDrawer from "../EditProcessWheelDrawer/EditProcessWheelDrawer";
import ViewProcessWheelDrawer from "../ViewProcessWheelDrawer/ViewProcessWheelDrawer";
import DeleteProcessWheelModal from "../DeleteProcessWheelModal/DeleteProcessWheelModal";

const ProcessWheelList: React.FC = () => {
  const {
    processWheels,
    totalCount,
    loading,
    error,
    pagination,
    sorting,
    searchTerm,
    status,
    handlePaginationChange,
    handleSortingChange,
    handleSearchChange,
    handleStatusChange,
    loadingCreate,
    loadingUpdate,
    loadingDelete,
    isCreateOpen,
    openCreate,
    closeCreate,
    editingProcessWheel,
    openEdit,
    closeEdit,
    viewingProcessWheel,
    openView,
    closeView,
    editFromView,
    deleteTarget,
    requestDelete,
    closeDelete,
    submitCreate,
    submitEdit,
    confirmDelete,
  } = useProcessWheels();

  const columns = useMemo(
    () =>
      createProcessWheelColumns({
        onView: openView,
        onEdit: openEdit,
        onDelete: requestDelete,
      }),
    [openView, openEdit, requestDelete],
  );

  return (
    <>
      <MainPageWrapper
        actions={<Button onClick={openCreate}>Create Process Wheel</Button>}
        error={error}
        title="Process Wheels"
      >
        <ProcessWheelFilters
          onSearchChange={handleSearchChange}
          onStatusChange={handleStatusChange}
          searchTerm={searchTerm}
          status={status}
        />

        <DataTable
          columns={columns}
          data={processWheels}
          error={error}
          loading={loading}
          noDataMessage="No process wheels found"
          onPageChange={(newPageIndex, newPageSize) =>
            handlePaginationChange({
              pageIndex: newPageIndex,
              pageSize: newPageSize,
            })
          }
          onSortingChange={handleSortingChange}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          rowKeyExtractor={(item) => item.uuid}
          sorting={sorting}
          totalCount={totalCount}
        />
      </MainPageWrapper>

      <CreateProcessWheelDrawer
        isOpen={isCreateOpen}
        loading={loadingCreate}
        onClose={closeCreate}
        onSubmit={submitCreate}
      />

      {editingProcessWheel && (
        <EditProcessWheelDrawer
          isOpen={!!editingProcessWheel}
          loading={loadingUpdate}
          onClose={closeEdit}
          onSubmit={submitEdit}
          processWheel={editingProcessWheel}
        />
      )}

      {viewingProcessWheel && (
        <ViewProcessWheelDrawer
          isOpen={!!viewingProcessWheel}
          onClose={closeView}
          onEdit={editFromView}
          processWheel={viewingProcessWheel}
        />
      )}

      <DeleteProcessWheelModal
        isOpen={!!deleteTarget}
        loading={loadingDelete}
        onClose={closeDelete}
        onConfirm={confirmDelete}
      />
    </>
  );
};

export default ProcessWheelList;
